(() => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://assets.homedepot-static.com/core/thd-customer/v4.12.1/thd-customer.js';
  document.getElementsByTagName('head')[0].appendChild(script);
})();
